import { useEffect } from "react";
import { setTitlePage } from "../../Functions";

const AboutUs = () => {

  useEffect(() => {
    setTitlePage('Nosotros')
  }, []);
  return (
    <div className="card p-5 text-gray-600">
      <div className="row px-3">
        <div className="col-12 p-5" style={{textAlign: 'justify'}}>
          <p className="text-amsm mt-3 fs-4 fw-bold ">Nosotros</p>
          <p>
            Asociación Médica Santa María (AMSM) fue constituida en el año 2000 por la comunidad de médicos staff de la Clínica Santa María.
          </p>
          <p>
            Nuestro compromiso es promover la excelencia de la práctica médica basada en la buena relación con la comunidad, velar por el desarrollo profesional y el bienestar de sus asociados, fomentar el ejercicio de la medicina de calidad y velar por el prestigio y la valoración social de la profesión médica.
          </p>
          <p>
            El foco de nuestra gestión radica en realizar y desarrollar las actividades de prestaciones médicas ambulatorias de los asociados y valorizaciones, mediante procesos eficientes y controlados, con alta calidad de servicio. Por ello, nuestra labor es velar por contar con procesos y servicios eficientes, de manera de cumplir con los objetivos y plazos de nuestra labor operacional.
          </p>
          <p>
            A su vez, nuestra Asociación busca impulsar iniciativas que agreguen valor a la comunidad médica, organizando actividades, colaborando con el desarrollo de eventos, realizar alianzas y convenios que beneficien a nuestros miembros y trabajar en conjunto con la Clínica Santa María para el logro de nuestros objetivos.
          </p>
          <p>
            AMSM cuenta con personas comprometidas y de alto desempeño, con el objetivo de entregar un servicio de calidad a los médicos, asociados y pacientes de Clínica Santa María.
          </p>

          <div style={{textAlign: 'center'}}>
            <img src="https://intranet.amsm.cl/files/AMSM.jpg" alt="" className="py-5 imgAboutUs"/>
          </div>
          <p>
            A través de su directorio AMSM promueve la colaboración e intercambio de información con Clínica Santa María, además de mantener relaciones con organismos y organizaciones vinculadas a la medicina en la labor gremial mediante su participación en la Federación Médica de Salud Privada.
          </p>
          <p className="text-amsm mt-3 fs-4 fw-bold ">Directorio</p>
            <p>PRESIDENTE: Dr. Jaime Prado</p>
            <p>VICEPRESIDENTE: Dr. Iñaki Zarraonandia</p>
            <p>DIRECTORES: Dr. Felipe Corvalán, Dr. Fernando Vargas, Dra. María Isabel Domínguez</p>

        </div>
      </div>
    </div>
  );
}

export default AboutUs;